import { render, staticRenderFns } from "./ArticleSource.vue?vue&type=template&id=765f6b22&"
import script from "./ArticleSource.vue?vue&type=script&lang=ts&"
export * from "./ArticleSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports